/**
 *  @fileOverview liveBinding module
 *
 *  @author       Daniel Jung <daniel.jung@possible.com>
 *
 */

const toArray = (nodeList) => {
  const res = [];
  let i = 0;
  const l = (nodeList && nodeList.length) || 0;
  for (i; i < l; i++) {
    res.push(nodeList[i]);
  }
  return res;
};

const liveBinding = (selector, eventType, callback, selectorException) => {
  document.addEventListener(eventType, (event) => {
    const nodeList = document.querySelectorAll(selector);
    const matches = toArray(nodeList);
    let nodeListExceptions = null;
    let matchesException = null;
    if (selectorException) {
      nodeListExceptions = document.querySelectorAll(selectorException);
      matchesException = toArray(nodeListExceptions);
    }

    if (matches) {
      let element = event.target;
      let index = matches.indexOf(element);
      let stopPropagation = false;

      while (element && index === -1) {
        element = element.parentElement;
        index = matches.indexOf(element);
        if (matchesException && matchesException.indexOf(element) === -1) {
          stopPropagation = true;
        }
      }

      if (index > -1 && !stopPropagation) {
        callback.call(element, event, element);
      }
    }
  }, false);
};

export default liveBinding;



// WEBPACK FOOTER //
// ./src/js/utils/live-event-binding.js